
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#171C26","fill-rule":"evenodd","d":"M4.73 5.93L8 9.2l3.269-3.268a1.226 1.226 0 011.65-.076l.082.076-4.999 4.998L3 5.931a1.224 1.224 0 011.73 0z","clip-rule":"evenodd"}})])
          )
        }
      }
    